// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__NI2QJ","icons8":"Footer_icons8__WwbTV"};